// @ts-expect-error untyped
import Autolinker from 'autolinker';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { useObjectTypeId } from '../../../v2/hooks/useObjectTypeId';
import { usePropertyValue } from '../../../v2/hooks/usePropertyValue';
import { useProperty } from '../../../v2/hooks/useProperty';
import { Button } from 'foundations-components/transitional/components/Button';
import { isFile } from 'customer-data-objects/property/PropertyIdentifier';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const linkifiers = {
  twitterhandle(value) {
    return {
      href: `https://twitter.com/${value}`,
      target: '_blank'
    };
  },
  email(value) {
    return {
      href: `mailto:${value}`,
      target: '_self'
    };
  },
  phone(value) {
    return {
      href: `tel:${value}`,
      target: '_self'
    };
  },
  mobilephone(value) {
    return {
      href: `tel:${value}`,
      target: '_self'
    };
  }
};

/**
 * This JSX is a hook instead of a component because we need to check conditionally whether the rendered result is truthy/falsy,
 * in order to be able to not pass content to FormControl's hoverContent prop.
 *
 * Were this a component, its 'value' would always be truthy and we would wind up passing empty, but present, hover content.
 */
export const useGetCommunicationLink = displayOptimized => {
  const value = usePropertyValue();
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  return useMemo(() => {
    if (!displayOptimized || !value || isFile(property)) {
      return null;
    }

    /*
    https://github.com/gregjacobs/Autolinker.js/issues/204
    Although we were initially doing this to prevent the performance concern
    in the issue above we are also getting a bit of functionality due to
    Autolinker.parse treating rich text hyperlinks as text which would render an
    external link. see: https://git.hubteam.com/HubSpot/customer-data-sidebar/pull/3501#discussion_r2579732
    */
    const sanitizedValue = value.toString().replace(/</g, '&lt;');
    const autolinker = new Autolinker({
      newWindow: true,
      twitter: false
    });
    const [firstMatch] = autolinker.parse(sanitizedValue);
    const autoLinkMatch = typeof sanitizedValue !== 'string' || !firstMatch ? {} : {
      href: firstMatch.getAnchorHref(),
      target: ['email', 'phone'].includes(firstMatch.getType()) ? '_self' : '_blank'
    };
    const linkProps = Object.prototype.hasOwnProperty.call(linkifiers, property.name) ? linkifiers[property.name](sanitizedValue, objectTypeId) : autoLinkMatch;
    if (!linkProps.href) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, Object.assign({
      use: "link"
    }, linkProps, {
      marginBlockStart: "-25",
      children: /*#__PURE__*/_jsx(ExternalLinkIcon, {
        size: "300"
      })
    }), "link");
  }, [displayOptimized, value, objectTypeId, property]);
};